
import React, { useState } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router'
import { SocialAPI } from '@api/social';
import { HotPerson, HotTopic, VoterDetial, PostEntryBtn, TopicBannerInfo, VoteWrapper, VoteTodo } from '@widget/community'
import I18n from '@utils/i18n';
import { getLoginPath } from '@utils/index'
import { message } from 'antd';
import { getClient } from '@api/index'
// import styles from '@styles/modules/communityTopic.module.css'
import { useAuthSession, useIsomorphicLayoutEffect, useAsideHeight } from '@lib/hooks'
import SocialFeed from '@widget/post/SocialFeed';
import { Tabs, TabPane, BackTop } from '@element/index';
import DetailLayout from '@components/DetailLayout';
import jwtToken from '@utils/jwtToken';
import Head from 'next/head'
import styles from './index.module.less';
import pick from 'lodash/pick'

export default function HotTopicDetial ({ topicData: defaultTopicData }) {
  const { ref: rightRef } = useAsideHeight()
  const [topicData, setTopicData] = useState(defaultTopicData)
  const [activeKey, setActiveKey] = useState('1');
  const router = useRouter();
  const isLogin = useAuthSession({ redirectTo: null });

  const id = router.query?.id ? router.query?.id : '';

  const getTopicDetial = async () => {
    const params = {
      topicId: id
    }
    const opts = {
      Authorization: jwtToken.getToken()
    }
    const res = await SocialAPI.getHotTopicDetial(params, opts)
    if (res && res.result) {
      setTopicData(res.result)
    } else {
      message.error(I18n.t(res.msgKey));
    }
  }
  useIsomorphicLayoutEffect(() => {
    setTopicData(defaultTopicData)
  }, [id])

  const handleVoteClick = async (params) => {
    if (!isLogin) {
      router.push(getLoginPath())
      return
    }
    const res = await getClient().reactions.add('LIKE', params.viewId, params.like ? { reverse: true } : {})
    if (!res.result) return;
    getTopicDetial()
  }
  return (
    <DetailLayout
      title={I18n.t('community')}
      contentClass={styles.container}
      className={styles.detailLayout}
    >
      <Head>
        <title>{I18n.t('community_t', { title: topicData?.content })}</title>
        <meta property="og:title" content={`${topicData?.desc}`} key="title" name="description" />
      </Head>
      <div className={styles.hotPersonDataCont}>
        <div className={styles.detialCont}>
          <TopicBannerInfo {...pick(topicData, ['backgroundUrl', 'content', 'viewCount', 'desc'])} />
          <VoteWrapper topicDetail={topicData}>
            {({ isSelected, square, opposition, displayInterval, oppose, agree, borderRadiusArr }) => {
              if (isSelected) {
                return <VoterDetial
                  displayInterval={displayInterval}
                  oppose={oppose}
                  borderRadiusArr={borderRadiusArr}
                  agree={agree}
                  square={square}
                  opposition={opposition}
                />
              }
              return (
                <VoteTodo square={square} opposition={opposition} handleVoteClick={handleVoteClick} />
              )
            }}
          </VoteWrapper>
          <div className={styles.feedWrapper}>
            <span className={cn(styles.postCount, styles.h5)}>{topicData.postCount}{I18n.t('postCountSuffix')}</span>
            {id && (
              <Tabs
                type='primary'
                onChange={(activeKey) => setActiveKey(activeKey)}
                activeKey={activeKey}
                tabBarExtraContent={<span className={cn(styles.postCount, styles.web)}>
                  {topicData.postCount}{I18n.t('postCountSuffix')}
                </span>}
              >
                <TabPane tab={<h2>{I18n.t('community_hot_topic')}</h2>} key='1' className={styles.posttab}>
                  <SocialFeed
                    feedType='topic'
                    topicId={id}
                    topicType='hot'
                    isLoadMore={true}
                  />
                </TabPane>
                <TabPane tab={<h2>{I18n.t('recent')}</h2>} key='2' className={styles.posttab}>
                  <SocialFeed
                    feedType='topic'
                    topicId={id}
                    topicType='newest'
                    isLoadMore={true}
                  />
                </TabPane>
              </Tabs>
            )}
          </div>
        </div>
        <div className={cn(styles.communityHotComponent, styles.topicRight, styles.right)} ref={rightRef}>
          <HotPerson />
          <HotTopic />
        </div>
      </div>
      <BackTop />
      <PostEntryBtn className={styles.postEntryBtn} topic={{
        id: topicData.id,
        content: topicData.content
      }} />
    </DetailLayout>
  )
}

export async function getServerSideProps (context) {
  const { jwt } = context.req.cookies || {};
  const params = {
    topicId: context?.query?.id
  }
  const opts = {
    Authorization: jwt,
    'Content-Type': 'text/xml;charset=UTF-8'
  }
  const res = await SocialAPI.getHotTopicDetial(params, opts)
  return { props: { topicData: res.result } }
}
